// extracted by mini-css-extract-plugin
export var audioPlayer = "_qf-0";